module.exports = __webpack_public_path__ + "static/img/header4.a8087ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header4.jpg
// module id = oKsf
// module chunks = 1